<template>
    <div class="vacancy" :style="`background-color: ${color}`">
        <div class="vacancy__body">
            <h3 class="vacancy__title">
                {{ vacancy.name }}
            </h3>
            <span class="vacancy__description" v-html="vacancy.description" />
            <div class="vacancy__buttons">
                <a
                    :href="resumeLink"
                    target="_blank"
                    class="vacancy__btn vacancy__btn--primary"
                    >Перейти к резюме</a
                >
                <a
                    :href="vacancyLink"
                    target="_blank"
                    class="vacancy__btn vacancy__btn--link"
                    >Описание вакансии</a
                >
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        vacancy: {
            type: Object,
            default: () => {},
        },
        color: {
            type: String,
            default: '#F0FAF2',
        },
    },
    computed: {
        resumeLink() {
            return `https://project.${window.rsvDomain}/${this.vacancy.projectId}`;
        },
        vacancyLink() {
            return `https://${window.rsvDomain}/vacancies/1/${this.vacancy.id}`;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/rem';
@import '~@/styles/mrem';
.vacancy {
    box-shadow: 0px 2px 10px 0px rgba(70, 99, 171, 0.2);
    overflow: hidden;
    border-radius: mrem(16);
    margin-bottom: mrem(16);

    @include on-desktop {
        margin-bottom: rem(24);
        border-radius: rem(16);
    }

    &__body {
        color: #251f45;
        background: #ffffff;
        margin-left: mrem(14);
        padding: mrem(16) mrem(32) mrem(24) mrem(32);

        @include on-desktop {
            margin-left: rem(14);
            padding: rem(16) rem(40) rem(16) rem(26);
        }
    }

    &__title {
        font-size: mrem(20);
        font-weight: 700;
        margin-top: 0;
        margin-bottom: mrem(10);
        line-height: mrem(28);

        @include on-desktop {
            font-size: rem(20);
            margin-bottom: rem(10);
            line-height: rem(28);
        }
    }

    &__description {
        font-size: mrem(14);
        font-weight: 500;
        line-height: mrem(26);
        margin-bottom: mrem(10);

        @include on-desktop {
            margin-bottom: rem(10);
            font-size: rem(14);
            line-height: rem(26);
        }
    }

    &__buttons {
        margin-top: mrem(20);
        display: flex;
        flex-direction: column;
        padding: 0;

        @include on-desktop {
            flex-direction: row;
            align-items: center;
            margin-top: rem(10);
        }
    }

    &__btn {
        display: flex;
        justify-content: center;
        font-size: mrem(14);
        font-weight: 700;

        @include on-desktop {
            font-size: rem(14);
            margin-top: 0;
        }

        &--primary {
            border-radius: mrem(10);
            height: mrem(42);
            border: none;
            color: #ffffff;
            background: #4663ab;
            align-items: center;

            @include on-desktop {
                border-radius: rem(10);
                margin-right: rem(16);
                padding: 0 rem(32);
                height: rem(42);
            }
        }

        &--link {
            color: #4663ab;
            margin-top: mrem(10);

            @include on-desktop {
                margin-top: 0;
            }
        }
    }
}
</style>
